import {css} from '@emotion/react';

export const getFonts = (path: string) => css`
  @font-face {
    font-family: 'X5 Sans UI';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src:
      url(${path}/X5-Sans-UI_Regular.woff2) format('woff2'),
      url(${path}/X5-Sans-UI_Regular.woff) format('woff');
  }

  @font-face {
    font-family: 'X5 Sans UI';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src:
      url(${path}/X5-Sans-UI_Medium.woff) format('woff2'),
      url(${path}/X5-Sans-UI_Medium.woff2) format('woff');
  }

  @font-face {
    font-family: 'X5 Sans UI';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src:
      url(${path}/X5-Sans-UI_Bold.woff) format('woff2'),
      url(${path}/X5-Sans-UI_Bold.woff2) format('woff');
  }
`;
